// extracted by mini-css-extract-plugin
export default {"iconBox":"Logout_iconBox__Xtqlx","logout":"Logout_logout__2SsjH"};